@if (!isNested) {
  <div class="aside-bar-wrapper">
    @if (showEvenWithoutStatement || statement) {
      <div class="aside-bar__header">
        <div class="aside-bar__header-open-dialog" (click)="openDialog()"></div>
        <app-workflow-steps
          [isLogged]="isLogged"
          [isMobileCondensed]="true"
          [statement]="statement"
          [isBusiness]="isBusiness"
          [workFlowController]="workFlowController"
        ></app-workflow-steps>
      </div>
    }
    @if (isLogged && (showEvenWithoutStatement || statement)) {
      <app-menu-bar-mobile></app-menu-bar-mobile>
    }
  </div>
}
